var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.$i18n.format(_vm.value.start, 'date')))]),(!_vm.isSingleDate)?_c('span',[_vm._v("- "+_vm._s(_vm.value.end ? _vm.$i18n.format(_vm.value.end, 'date') : '?'))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }